import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/The-last-Gemini-/The-last-Gemini-/src/app/sign-up-login-screen/components/AuthClient.tsx");
